module.exports = __webpack_public_path__ + "img/retain.ca2c604d.jpg";